import { View } from '@play-co/timestep-core/ui';
import { ButtonScaleViewOpts } from 'src/lib/ui/components/ButtonScaleView';
import { now, user } from 'src/StateObserver';
import {
  getStreakBattleRoyaleRemainingTime,
  isStreakBattleRoyaleEnabled,
  isStreakBattleRoyaleRewarded,
  getStreakBattleRoyaleStatus,
  getStreakBattleRoyaleActiveTheme,
} from 'src/replicant/streakbattleroyale/streakbattleroyale.getters';
import { AssetGroup } from '@play-co/timestep-core';
import { FeatureButton } from '../components/FeatureButton';
import { spineLoader } from '@play-co/timestep-spine';

const assets = {
  spine: {
    loadMethod: spineLoader,
    url: 'assets/ui/match2/streakbattleroyaleV2/button/home-button',
  },
  label: 'assets/ui/match2/streakbattleroyaleV2/button/label-bg.png',
};

export class StreakBattleRoyaleButtonAnimated extends FeatureButton<'lightning'> {
  public override getElementsToApplyFilter() {
    const elements: View[] = [];
    if (this.labelPanel) elements.push(this.labelPanel);
    if (this.spine) elements.push(this.spine);
    return elements;
  }

  constructor(opts: ButtonScaleViewOpts) {
    super({
      width: 144,
      height: 160,
      pressedOffsetY: 5,
      labelPanel: {
        offsetX: 4,
        offsetY: 5,
        labelOffsetX: -2,
        labelOffsetY: -4,
        background: {
          image: assets.label,
        },
      },
      ...opts,
    });

    this.animationStateMap = {
      lightning: {
        type: 'spine',
        assetGroup: new AssetGroup(Object.values(assets)),
        url: assets.spine.url,
        scale: 0.67,
        offsetX: 1,
        offsetY: 80,
        sequence: ['idle'],
      },
    };

    this.setNotification({
      condition: (user) =>
        !this.isLocked && getStreakBattleRoyaleStatus(user) === 'available',
    });
  }

  public update() {
    const activeTheme = getStreakBattleRoyaleActiveTheme(user());

    // If the event is not enabled or rewarded, hide the button
    if (
      !isStreakBattleRoyaleEnabled(user()) ||
      isStreakBattleRoyaleRewarded(user())
    ) {
      this.hide();
      return;
    }

    // Otherwise, show the button
    this.show();
    this.updateLabel();
    this.setAnimationState(activeTheme);
  }

  private updateLabel() {
    const status = getStreakBattleRoyaleStatus(user());
    switch (status) {
      case 'available':
        this.setLabelLocaleText('match2.leagues.join');
        break;
      case 'active':
      case 'expired':
      case 'failed':
        this.setLabelTime({
          duration: getStreakBattleRoyaleRemainingTime(user(), now()),
        });
        break;
      case 'completed':
        this.setLabelLocaleText('match2.dailyBonus.claim');
        break;
    }
  }
}
